import { Link } from "react-router-dom";
import VideoCard from "@/components/base/VideoCard";
import type { Video } from "@/types/video";
import { relativeTime } from "@/utils/format";

interface VideoGridSectionProps {
  title: string;
  subtitle: string;
  videos: Video[];
  moreTo?: string;
  moreLabel?: string;
  showRank?: boolean;
}

export default function VideoGridSection({
  title,
  subtitle,
  videos,
  moreTo,
  moreLabel = "查看全部",
  showRank = false,
}: VideoGridSectionProps) {
  return (
    <section className="mx-auto w-full px-4 py-10 md:px-6 md:py-12">
      <div className="mb-8 flex items-end justify-between gap-4">
        <div>
          <h2 className="font-heading text-xl font-extrabold text-foreground-50 md:text-2xl">{title}</h2>
          <p className="mt-2 text-sm text-foreground-400">{subtitle}</p>
        </div>
        {moreTo && (
          <Link
            to={moreTo}
            className="hidden items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-400 transition-colors hover:text-primary-300 sm:flex"
          >
            {moreLabel} <i className="ri-arrow-right-s-line text-base" />
          </Link>
        )}
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {videos.map((video, i) => (
          <div key={video.id} className="relative">
            {showRank && (
              <span
                className={`absolute -left-1 -top-1 z-10 flex h-7 w-7 items-center justify-center rounded-md font-label text-sm font-extrabold ${
                  i < 3 ? "bg-primary-500 text-background-950" : "bg-background-700 text-foreground-200"
                }`}
              >
                {i + 1}
              </span>
            )}
            <VideoCard
              id={video.id}
              title={video.title}
              cover={video.cover}
              streamerName={video.streamerName}
              streamerAvatar={video.streamerAvatar}
              duration={video.duration}
              views={video.views}
              subcategory={video.subcategory}
              publishedLabel={relativeTime(video.publishedAt)}
            />
          </div>
        ))}
      </div>
    </section>
  );
}